/**
 * @desc 费用类型报表导入
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/costType/import`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
